import { graphql } from '../../graphql';

export const cityQuery = graphql(`
  query City($id: ID!) {
    city(id: $id) {
      id
      name
      slug
      latitude
      longitude
      locations {
        id
        name
        locationGroupId
      }
    }
  }
`);
